import { useUnit } from 'effector-react'

import { $kpiList, $totalCountOfKPI, $totalKPI, getKPI, kpiListMounted } from './model'
import { ProcessingTransactionRequest } from './types'

export const useProcessingList = () => {
  const kpiList = useUnit($kpiList)
  const totalKPI = useUnit($totalKPI)
  const loading = useUnit(getKPI.pending)
  const totalCountOfKPI = useUnit($totalCountOfKPI)

  const onChangeProcessingList = ({
    userIds,
    beginPeriodAt,
    endPeriodAt,
    page,
    limit,
  }: ProcessingTransactionRequest) => {
    kpiListMounted({ userIds, beginPeriodAt, endPeriodAt, page, limit })
  }

  return { kpiList, loading, onChangeProcessingList, totalCountOfKPI, totalKPI }
}
